import { Card, Flex } from "antd";

import {
  HvacInstallationsBySubcontractor,
  OutstandingContractorQuotes,
} from "projects/components";
import { LightingInstallationsBySubcontractor } from "projects/components/lighting-installations-by-subcontractor/LightingInstallationsBySubcontractor";
import {
  IInstallationBySubcontractor,
  IOutstandingContractorQuote,
} from "projects/models";

import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  hvacInstallationsBySubcontractor?: IInstallationBySubcontractor[];
  lightingInstallationsBySubcontractor?: IInstallationBySubcontractor[];
  outstandingContractorQuotes?: IOutstandingContractorQuote[];
};

export const ContractorDashboardProjectsCard = ({
  loading,
  hvacInstallationsBySubcontractor,
  lightingInstallationsBySubcontractor,
  outstandingContractorQuotes,
}: Props) => {
  return (
    <Card
      className='contractor-dashboard-projects-card-container'
      loading={loading}
      bordered={false}
      data-testid='contractorDashboardProjectsCard'
    >
      <Flex vertical gap={variables.gap}>
        <h1>Projects</h1>
        <HvacInstallationsBySubcontractor
          hvacInstallationsBySubcontractor={hvacInstallationsBySubcontractor ?? []}
          height={variables.defaultComponentHeight}
        />
        <LightingInstallationsBySubcontractor
          lightingInstallationsBySubcontractor={lightingInstallationsBySubcontractor ?? []}
          height={variables.defaultComponentHeight}
        />
        <OutstandingContractorQuotes outstandingContractorQuotes={outstandingContractorQuotes ?? []} />
      </Flex>
    </Card>
  );
};
